import { Link } from "react-router-dom";
import { Droplets, Instagram, Facebook, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A2520] text-stone-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-xl bg-[#10B981] flex items-center justify-center">
                <Droplets className="w-5 h-5 text-white" />
              </div>
              <span className="font-display text-lg font-semibold text-white">IV Therapy Finder</span>
            </div>
            <p className="text-sm text-stone-400 max-w-sm leading-relaxed">
              The #1 directory for IV therapy clinics and mobile infusion providers across the United States.
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#10B981]/20 flex items-center justify-center transition" data-testid="footer-instagram"><Instagram className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#10B981]/20 flex items-center justify-center transition"><Facebook className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#10B981]/20 flex items-center justify-center transition"><Twitter className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-white mb-4">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/search" className="hover:text-[#10B981] transition">All Providers</Link></li>
              <li><Link to="/search?type=mobile" className="hover:text-[#10B981] transition">Mobile IV Therapy</Link></li>
              <li><Link to="/search?type=clinic" className="hover:text-[#10B981] transition">IV Clinics</Link></li>
              <li><Link to="/search?service=NAD%2B" className="hover:text-[#10B981] transition">NAD+ Therapy</Link></li>
              <li><Link to="/blog" className="hover:text-[#10B981] transition">Blog & Resources</Link></li>
              <li><Link to="/compare" className="hover:text-[#10B981] transition">Compare Providers</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-white mb-4">Top Cities</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/search?city=Los Angeles" className="hover:text-[#10B981] transition">Los Angeles</Link></li>
              <li><Link to="/search?city=Miami" className="hover:text-[#10B981] transition">Miami</Link></li>
              <li><Link to="/search?city=New York" className="hover:text-[#10B981] transition">New York</Link></li>
              <li><Link to="/search?city=Las Vegas" className="hover:text-[#10B981] transition">Las Vegas</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-white mb-4">For Business</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/add-business" className="hover:text-[#10B981] transition">List Your Business</Link></li>
              <li><Link to="/for-businesses" className="hover:text-[#10B981] transition">Pricing & Plans</Link></li>
              <li><Link to="/login" className="hover:text-[#10B981] transition">Business Login</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-stone-500">
          <p>© {new Date().getFullYear()} IV Therapy Finder. All rights reserved.</p>
          <p className="max-w-2xl text-center md:text-right">
            Medical disclaimer: Content on this site is for informational purposes only and is not a substitute for professional medical advice. Always consult a qualified medical provider before starting any treatment.
          </p>
        </div>
      </div>
    </footer>
  );
}
